import React, { useMemo } from "react";

// Servisni sloj
import { getFleetVehicleDamagesAPI } from "services/api/fleet/vehicles/damages/api";
import { initialFleetVehicleDamageSearchForm } from "services/api/fleet/vehicles/damages/consts";
import { FleetVehicleDamageRow } from "services/api/fleet/vehicles/damages/types";
import { initialDataWithPagination } from "services/api/consts";
import { DataWithPagination } from "services/api";

// Hooks
import {
  DropdownCacheKey,
  buildDropdownCacheKey,
  useDropdownCache,
} from "services/hooks/useDropdownCache";

// UI
import { Dropdown } from "../Dropdown";
import { DropdownOption } from "../Dropdown/types";

import { VehicleDamageDropdownProps } from "./types";

/** Vozilo rijetko ima više od nekoliko šteta, pa se dohvaćaju odjednom. */
const DAMAGE_PAGE_SIZE = 100;

/**
 * Odabir štete jednog vozila. Nema "kreiraj novu" — šteta se unosi svojim čarobnjakom,
 * s fotografijama i pinovima, pa se ovdje samo bira.
 */
const VehicleDamageDropdown: React.FC<VehicleDamageDropdownProps> = (props) => {
  const {
    name,
    disabled,
    required,
    label,
    error,
    value,
    width,
    placeholder,
    vehicleId,
    onChange,
  } = props;

  const cacheKey = buildDropdownCacheKey(DropdownCacheKey.VehicleDamages, vehicleId);

  const { data, isLoading } = useDropdownCache<DataWithPagination<FleetVehicleDamageRow>>(
    cacheKey,
    () =>
      getFleetVehicleDamagesAPI(
        { ...initialDataWithPagination.pagination, pageSize: DAMAGE_PAGE_SIZE },
        { ...initialFleetVehicleDamageSearchForm, vehicleId }
      ),
    5 * 60 * 1000,
    !!vehicleId
  );

  const options: DropdownOption[] = useMemo(
    () => (data?.data ?? []).map((damage) => ({ value: damage.id, text: damage.name })),
    [data]
  );

  return (
    <Dropdown
      name={name}
      label={label}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={onChange}
      error={error}
      required={required}
      disabled={disabled}
      width={width}
      isLoading={isLoading}
    />
  );
};

export default React.memo(VehicleDamageDropdown);
